import { getSentryExtra } from '../error/getSentryExtra';
import { getDtbIdForAcq129PurchaseFlow } from '../pricingUtils/getDtbIdForAcq129PurchaseFlow';
import { Data } from '../signup-data/DATA';
import { updateCurrencyCode, updateDtbId, updateProductResponse, updatePromotionsResponse, updateRequiredOnboarding } from '../store/pricing/action-creators';
import { PricingActionTypes } from '../store/pricing/action-types';
import { getSignupDataValue, isSignupDataCompleted } from '../store/signup-data/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { PricingTier } from '../types';
import { EndpointKey } from './EndpointKey';
import { getProducts } from './http-pricing/getProducts';
import { getPromotions } from './http-pricing/getPromotions';
import { LOG } from './HttpRequester';
export const EndpointsPricing = {
  [EndpointKey.PricingProducts]: {
    method: getProducts,
    handleSuccess: (data, dispatch) => {
      dispatch(updateProductResponse(data));
    },
    handleError: (error, dispatch) => {
      dispatch(Tracker.signupInteraction('pricing-products-failed'));
      LOG.error('Pricing Products Information Request Failed', {
        extra: getSentryExtra(error)
      });
    },
    reduxActionType: PricingActionTypes.FetchProducts
  },
  [EndpointKey.PricingPromotions]: {
    method: getPromotions,
    handleSuccess: (data, dispatch) => {
      const {
        promotions,
        defaultCurrency,
        requiredOnboarding
      } = data;
      dispatch(updatePromotionsResponse(promotions));
      dispatch(updateCurrencyCode(defaultCurrency));
      dispatch(updateRequiredOnboarding(requiredOnboarding));
    },
    handleError: (error, dispatch) => {
      dispatch(Tracker.signupInteraction('pricing-promotions-failed'));
      LOG.error('Pricing Promotions Information Request Failed', {
        extra: getSentryExtra(error)
      });
    },
    reduxActionType: PricingActionTypes.FetchPromotions
  },
  [EndpointKey.CreateDtbConfig]: {
    method: getDtbIdForAcq129PurchaseFlow,
    handleSuccess: (data, dispatch) => {
      const {
        id: dtbId
      } = data;
      dispatch(updateDtbId(dtbId));
    },
    handleError: (error, dispatch) => {
      dispatch(Tracker.signupInteraction('create-dtb-config-public-failed'));
      LOG.error('Crate DTB Config Public Request failed: ', {
        extra: getSentryExtra(error)
      });
    },
    stateCheck: state => {
      const pricingTier = getSignupDataValue(state, Data.PricingPath);
      const isPricingTierCompleted = isSignupDataCompleted(state, Data.PricingPath);
      return isPricingTierCompleted && pricingTier === PricingTier.Starter;
    },
    once: true
  }
};